<script lang="ts">
  import { Badge, Col, Row, Table } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import { BasicPills, BasicPillsMessage, LabelWithIcon, Primary, PrimaryLabel, PrimaryLabelMessage } from "../../../../utils/Constant/Constant";
</script>
<Col sm="12" >
    <Card headerTitle={"Badges"}>
      <div slot="contentbody">
        <Row class="card-block">
          <Col sm="12" lg="12" xl="12" >
            <div class="table-responsive">
              <Table bordered>
                <tbody>
                  <tr>
                    <td class="pills-component">{BasicPills}</td>
                    <td class="w-50">
                        <Badge color="primary">{Primary}</Badge>
                    </td>
                    <td><span>{@html BasicPillsMessage}</span></td>
                  </tr>
                  <tr>
                    <td>{LabelWithIcon}</td>
                    <td class="w-50 m-5">
                        <Badge color="primary" class="label-square">
                          <i class="fa fa-paperclip fa-lg p-r-5"></i>{PrimaryLabel}
                        </Badge>
                    </td>
                    <td><span>{@html PrimaryLabelMessage}</span></td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
</Col>